export default __webpack_public_path__ + "static/media/feather _ dollar-sign.ac6eb5d0.svg";